import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/fcc-compliance-statements/_common/FccComplianceStatementTemplate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/PageLayoutV3/index.tsx");
